import * as React from 'react';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

export interface IQuantityInputProps {
    product: SimpleProduct | undefined;
    quantity: number;
    breakoff: boolean;
    min?: number;
    showOnlyIncrementDecrement?: boolean;
    showNonBreakoffAmount: boolean;
    onQuantityChange: (quantity: number) => void;
    BuyButton?: React.ReactNode;
}

const QuantityInput = (props: IQuantityInputProps) => {
    const {
        product,
        quantity,
        breakoff,
        min,
        showOnlyIncrementDecrement,
        showNonBreakoffAmount,
        onQuantityChange
    } = props;

    const baseClassName = 'quantity-input';
    // Check if there is a friendly UOM defined on the SimpleProduct
    const friendlyUOM = product?.ExtensionProperties?.find((x) => x.Key === 'FRIENDLYUOM')?.Value?.StringValue;
    const uom = friendlyUOM || product?.DefaultUnitOfMeasure;
    // const selectedUOM = breakoff ? uom : 'KASSE(R)';
    const multiplier = breakoff ? product?.Behavior?.MultipleOfQuantity || 1 : product?.Behavior?.DefaultQuantity || 1;

    const onIncrement = () => {
        const multiplier = breakoff ? product?.Behavior?.MultipleOfQuantity || 1 : product?.Behavior?.DefaultQuantity || 1;
        const newQuantity = quantity + multiplier;
        const minimumQuantity = (min || 0) * multiplier;

        onQuantityChange(Math.max(minimumQuantity, newQuantity));
    };

    const onDecrement = () => {
        const multiplier = breakoff ? product?.Behavior?.MultipleOfQuantity || 1 : product?.Behavior?.DefaultQuantity || 1;
        const newQuantity = Math.max(0, quantity - multiplier);
        const minimumQuantity = (min || 0) * multiplier;

        onQuantityChange(Math.max(minimumQuantity, newQuantity));
    };

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // We're essentially changing the displayQuantity instead of the actual quantity
        const newQuantity = parseFloat(e.target.value) || 0;
        const minimumQuantity = (min || 0) * multiplier;

        if (breakoff) {
            onQuantityChange(Math.max(minimumQuantity, newQuantity));
        } else {
            onQuantityChange(Math.max(minimumQuantity, newQuantity * multiplier));
        }
    };

    const displayQuantity = product && parseFloat((quantity / multiplier).toFixed(2));

    return (
        <div className={baseClassName}>
            <div className={`${baseClassName}__quantity-container`}>
                <div className={`${baseClassName}__quantity-controls`}>
                    <button
                        className={`${baseClassName}__quantity-controls__minus`}
                        disabled={!product}
                        onClick={onDecrement}
                    >
                        -
                    </button>
                    <input
                        className={`${baseClassName}__quantity-controls__input`}
                        type='number'
                        min={min}
                        onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                            }
                        }}
                        onChange={onInputChange}
                        value={displayQuantity} />
                    <button
                        className={`${baseClassName}__quantity-controls__plus`}
                        disabled={!product}
                        onClick={onIncrement}
                    >
                        +
                    </button>
                    {!showOnlyIncrementDecrement && product && (
                        <span className={`${baseClassName}__quantity-controls__quantity`}>
                            {showNonBreakoffAmount && (!breakoff && multiplier > 1)
                                ? `${displayQuantity} X ${multiplier} ${uom}`
                                : `${displayQuantity} ${uom}` }
                        </span>
                    )}
                </div>

                <div className={`${baseClassName}__buy-container`}>
                    {props.BuyButton}
                </div>
            </div>
        </div>
    );
};

export default QuantityInput;
